document.addEventListener("DOMContentLoaded", function () {
  // open first accordion
  const firstCollapse = document.querySelector(".investor-accordion .collapse");
  if (firstCollapse) {
    $(firstCollapse).collapse("show");
  }

  // Allow multiple open accordions, no auto-closing)
  $(".investor-accordion .collapse").on("show.bs.collapse", function () {
    // Do nothing
  });
});
